import { Label, Layout, Select, Switch, Text, Tag } from '@loadsmart/loadsmart-ui'
import { Selectable } from '@loadsmart/loadsmart-ui/dist/hooks/useSelectable'
import { Divider, Card, CardHeader, CardContent, Typography, Grid, Stack, Box } from '@mui/material'
import LSDate, { DATE_FORMAT_MMDDYYYYHHMMSS } from 'common/Date.helpers'
import { onSearchTradingPartners } from 'common/helpers/kraken-core/hooks'
import EventLike from 'common/types/EventLike'
import { PartnershipDetail } from 'common/types/kraken-core/Partnership'
import { TradingPartner } from 'common/types/kraken-core/TradingPartner'

export interface ParntershipFormProps {
  partnership: PartnershipDetail
  onUpdate?: (partnership: PartnershipDetail) => void
  isEdit?: boolean
}

const DATASOURCES = {
  TRADING_PARTNER: [
    () => ({
      type: 'string',
      adapter: {
        getKey: (tp: TradingPartner) => tp.id || '',
        getLabel: (tp: TradingPartner) => tp.name || '',
      },
      fetch: onSearchTradingPartners,
    }),
  ],
}

export default function ParntershipForm({ partnership, onUpdate, isEdit }: ParntershipFormProps) {
  const handleFieldUpdate = (event: EventLike<any>) => {
    const fieldName = event.target.name as string
    let value = event.target.value

    if (fieldName === 'is_active') {
      value = event.target.checked
    }

    if (onUpdate) {
      console.log(fieldName, value)
      onUpdate({
        ...partnership,
        [fieldName]: value,
      })
    }
  }

  return (
    <Layout.Stack space="s">
      {isEdit ? (
        <>
          <Layout.Group justify="space-between" align="flex-start">
            <Layout.Stack space="s">
              <Text variant="caption-bold">ID</Text>
              <Text variant="caption">{partnership.id}</Text>
            </Layout.Stack>
            <Layout.Stack space="s" aria-label="created_at">
              <Text variant="caption-bold">Created at</Text>
              <Text variant="caption">
                {LSDate(partnership.created_at)?.format(DATE_FORMAT_MMDDYYYYHHMMSS)}
              </Text>
            </Layout.Stack>
            <Layout.Stack space="s" aria-label="updated_at">
              <Text variant="caption-bold">Updated at</Text>
              <Text variant="caption">
                {LSDate(partnership.updated_at)?.format(DATE_FORMAT_MMDDYYYYHHMMSS)}
              </Text>
            </Layout.Stack>
            <Layout.Stack space="s">
              <Text variant="caption-bold">Active?</Text>
              <Switch
                name="is_active"
                active={partnership.is_active}
                onToggle={handleFieldUpdate}
                onChange={handleFieldUpdate}
              />
            </Layout.Stack>
          </Layout.Group>
          <Divider className="p-2" />
          {/* Party and Counterparty cards */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Party" />
                <CardContent>
                  <Stack spacing={2}>
                    <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                      {partnership.party?.name}
                    </Typography>
                    {(partnership.party as any)?.metadata?.tags &&
                      (partnership.party as any).metadata.tags.length > 0 && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                          {(partnership.party as any).metadata.tags.map(
                            (tag: string, index: number) => (
                              <Tag key={index} variant="accent">
                                {tag}
                              </Tag>
                            )
                          )}
                        </Box>
                      )}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Counterparty" />
                <CardContent>
                  <Stack spacing={2}>
                    <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                      {partnership.counterparty?.name}
                    </Typography>
                    {(partnership.counterparty as any)?.metadata?.tags &&
                      (partnership.counterparty as any).metadata.tags.length > 0 && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                          {(partnership.counterparty as any).metadata.tags.map(
                            (tag: string, index: number) => (
                              <Tag key={index} variant="accent">
                                {tag}
                              </Tag>
                            )
                          )}
                        </Box>
                      )}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </>
      ) : null}

      {!isEdit && (
        <Layout.Switcher className="w-full">
          <Layout.Stack space="s">
            <Label>Party</Label>
            <Select
              name="party"
              id="select-trading-partner"
              onChange={e => handleFieldUpdate(e)}
              value={
                partnership.party
                  ? ({
                      value: partnership.party.id,
                      label: partnership.party.name,
                    } as Selectable)
                  : undefined
              }
              datasources={DATASOURCES.TRADING_PARTNER}
              disabled={false}
            />
          </Layout.Stack>
          <Layout.Stack space="s">
            <Label>Counter Party</Label>
            <Select
              name="counterparty"
              id="select-trading-partner"
              onChange={e => handleFieldUpdate(e)}
              value={
                partnership.counterparty
                  ? ({
                      value: partnership.counterparty.id,
                      label: partnership.counterparty.name,
                    } as Selectable)
                  : undefined
              }
              datasources={DATASOURCES.TRADING_PARTNER}
              disabled={false}
            />
          </Layout.Stack>
        </Layout.Switcher>
      )}
    </Layout.Stack>
  )
}
